import { Grid } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import React, { useEffect, useLayoutEffect, useState } from 'react';
import CustomTypo from '../../components/CustomTypo';
import { domainName } from '../../../portal.config';
import { getAppCfg, getContacts, getLanguage } from '../../utils/common';
import { shortcuts } from '../../../portal.menu.config';
import { useTranslation } from 'react-i18next';
import theme from '../../theme.css';
import SpendingPreferencesController from '../spending-preferences/SpendingPreferencesController';
import BarcodeView from './BarcodeView';
import ReferFriend from '../refer-friend/ReferFriend';
import MyProfile from '../my-profile/MyProfile';
import TopupWalletController from '../topup-wallet/TopupWalletController';
import LocationsController from '../locations/LocationsController';
import ServiceRequestsController from '../service-requests/ServiceRequestsController';
import AccountAnalysisController from '../account-analysis/AccountAnalysisController';
import MyAccount from '../my-account/MyAccount';
import RedeemPassController from '../redeem-pass/RedeemPassController';
import ReclaimPurchaseTransactionCode from '../reclaim-purchase/ReclaimPurchaseTransactionCode';
import classNames from 'classnames';
import { ProfileIcon } from '../../components/icons';
import { useHistory } from 'react-router-dom';
import { paths } from '../../../portal.router.config';

const useStyles = makeStyles((theme) => ({
    boxs: {
        alignItems: 'center',
        width: '100%',
        flexDirection: 'row',
        flexWrap: 'nowrap',
        overflowX: 'auto',
        overflowY: 'hidden',
    },
    item: {
        // minWidth: 120,
        width: '100%',
        textAlign: 'center',
        padding: theme.spacing(0, 2),
        cursor: 'pointer',
    },
    boxIcon: {
        position: 'relative',
    },
    icon: {
        background: theme.palette.background.primary,
        padding: 8,
        width: 50,
        height: 50,
        borderRadius: 50,
        alignItems: 'center',
        justifyContent: 'center',
        display: 'flex',
        // position: 'absolute',
        margin: 'auto',
    },
    boxName: {
        // paddingTop: theme.spacing(4),
        marginTop: -25,
    },
    name: {
        background: theme.palette.background.card,
        padding: theme.spacing(2),
        borderRadius: theme.spacing(5),
        // height: 80,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
    title: {
        padding: theme.spacing(4, 2),
        marginTop: theme.spacing(2),
        whiteSpace: 'nowrap'
    },
}));

export default function ShortcutsViewNew(props) {
    const { t } = useTranslation();
    const history = useHistory();
    const classes = useStyles();
    const [open, setOpen] = useState({});
    const [authentication_code, setAuthenticationCode] = useState('');
    const [widthShortcut, setWidthShortcut] = useState(null);

    useLayoutEffect(() => {
        function updateSize() {
            let widthShortcuts = window.outerWidth - 30;
            console.log("widthShortcuts===", widthShortcuts);
            setWidthShortcut(widthShortcuts);
        }
        window.addEventListener('resize', updateSize);
        updateSize();
        return () => window.removeEventListener('resize', updateSize);
    }, []);
    
    useEffect(() => {
        onLoad();
    }, []);

    const onLoad = async () => {
        let contacts = await getContacts();
        if (contacts && contacts.code) setAuthenticationCode(contacts.code);
    }

    const onClick = (target) => {
        if(target === 'locations') history.push(paths.location);
        setOpen(prevState => ({
            ...prevState,
            [target]: true
        }));
    }

    const onCloseItem = (target) => {
        setOpen(prevState => ({
            ...prevState,
            [target]: false
        }));
    }


    const appConfig = getAppCfg();
    const showShortcutTopup = appConfig.features && appConfig.features.rewards && appConfig.features.finance_details && appConfig.features.finance_details.wallet_top_up ? appConfig.features.finance_details.wallet_top_up : false;
    const showShortcutReferfriend = appConfig.features && appConfig.features.rewards_details && appConfig.features.rewards_details.refer_friend ? appConfig.features.rewards_details.refer_friend : false;
    const showShortcutSpendPreference = appConfig.features && appConfig.features.rewards_details && appConfig.features.rewards_details.otp_spend ? appConfig.features.rewards_details.otp_spend : false;
    const showShortcutScanQR = appConfig.features && appConfig.features.rewards_details && appConfig.features.rewards_details.customer_selfservice_purchases ? appConfig.features.rewards_details.customer_selfservice_purchases : false;
    const showShortcutServiceRequest = appConfig.features && appConfig.features.crm_details && appConfig.features.crm_details.service_requets ? appConfig.features.crm_details.service_requets : false;
    const showShortcutRedeemAPass = appConfig.features && appConfig.features.finance_details && appConfig.features.finance_details.redeem_pass ? appConfig.features.finance_details.redeem_pass : false;
    const showTopupAccount = domainName === 'ayna' && document._portalConfig.usePaymentLocal ? true : false;
    const showAccountMenu = domainName === 'ayna' && !document._portalConfig.usePaymentLocal ? true : false;
    const reclaim_purchase_methods = appConfig && appConfig.features && appConfig.features.rewards_details && appConfig.features.rewards_details.reclaim_purchase_methods && appConfig.features.rewards_details.reclaim_purchase_methods.length > 0 ? appConfig.features.rewards_details.reclaim_purchase_methods : null;
    let showReclaimPurchase = false;
    let showReclaimPurchaseTransactionCode = false;
    if(reclaim_purchase_methods && reclaim_purchase_methods.length > 0){
        if(reclaim_purchase_methods.length === 1){
            if(reclaim_purchase_methods.includes('TRX_CODE')) showReclaimPurchaseTransactionCode = true;
            else if(reclaim_purchase_methods.includes('BARCODE')) showReclaimPurchase = true;
        }else{
            if(reclaim_purchase_methods.includes('TRX_CODE')) showReclaimPurchaseTransactionCode = true;
            if(reclaim_purchase_methods.includes('BARCODE')) showReclaimPurchase = true;
        }
    }
    console.log("reclaim_purchase_methods===", reclaim_purchase_methods)
    let language = getLanguage("LANGUAGE");
    console.log("language ===", language);
    return (
        <Grid item xs={12}>
            <Grid item xs={12} container className={classes.boxs} style={{ width: widthShortcut }}>
                {shortcuts && shortcuts.length > 0 && shortcuts.map((item, index) => {
                    if ((item.id === 'topup_wallet' && !showShortcutTopup) || (item.id === 'refer_friend' && !showShortcutReferfriend) || (item.id === 'redeem_pass' && !showShortcutRedeemAPass)
                        || (item.id === 'service_requests' && !showShortcutServiceRequest) || (item.id === 'scan_qr_code' && !showShortcutScanQR) ||
                        (item.id === 'spending_preferences' && !showShortcutSpendPreference) || (item.id === 'locations' && domainName === 'ayna')
                        || (item.id === 'barcode' && domainName === 'ayna') || (item.id === 'topup_account' && !showTopupAccount) 
                        || (item.id === 'my_account' && !showAccountMenu) || (item.id === 'reclaim' && (!reclaim_purchase_methods || reclaim_purchase_methods.length === 0))) {
                        return null;
                    }
                    else {
                        return (
                            <Grid key={index} item className={classNames([classes.item])} id={"shortcut_" + item.id} onClick={() => onClick(item.id)}>
                                <Grid item xs={12} className={classes.boxIcon}>
                                    <Grid item xs={12} className={classes.icon}>
                                        <item.icon fill={theme.palette.icon.active} style={{ marginRight: 0, color: theme.palette.icon.active, width: 24, height: 24, }} />
                                    </Grid>
                                </Grid>
                                <Grid item xs={12} className={classes.boxName}>
                                    <Grid item xs={12} className={classes.name}>
                                        <CustomTypo className={classes.title}>{t(item.title)}</CustomTypo>
                                    </Grid>
                                </Grid>
                        </Grid>
                        );
                    }
                })}
            </Grid>
            {/* <Grid item className={classes.item}>
                <Grid item xs={12} className={classes.boxIcon}>
                    <Grid item xs={12} className={classes.icon}>
                        <ProfileIcon />
                    </Grid>
                </Grid>
                <Grid item xs={12} className={classes.boxName}>
                    <Grid item xs={12} className={classes.name}>
                        <p>{t("Service Request AAAA")}</p>
                    </Grid>
                </Grid>
            </Grid> */}
            {open.spending_preferences && <SpendingPreferencesController
                open={open.spending_preferences}
                onCloseItem={() => onCloseItem('spending_preferences')}
            />}
            {open.barcode && <BarcodeView
                open={open.barcode}
                onShowBarcode={() => onCloseItem('barcode')}
                authentication_code={authentication_code}
            />}
            {open.refer_friend && <ReferFriend
                open={open.refer_friend}
                handleDrawerOtherToggle={() => onCloseItem('refer_friend')}
            />}
            {open.profile && <MyProfile
                open={open.profile}
                handleDrawerOtherToggle={() => onCloseItem('profile')}
            />}
            {open.topup_wallet && <TopupWalletController
                open={open.topup_wallet}
                onClose={() => onCloseItem('topup_wallet')}
            />}
            {open.locations && <LocationsController
                open={open.locations}
                onCloseMap={() => onCloseItem('locations')}
            />}
            {open.service_requests && <ServiceRequestsController
                open={open.service_requests}
                onClose={() => onCloseItem('service_requests')}
            />}
            {open.topup_account && <AccountAnalysisController
                open={open.topup_account}
                onClose={() => onCloseItem('topup_account')}
            />}
            {open.my_account && <MyAccount
                open={open.my_account}
                handleDrawerOtherToggle={() => onCloseItem('my_account')}
            />}
            {open.redeem_pass && <RedeemPassController
                open={open.redeem_pass}
                onClose={() => onCloseItem('redeem_pass')}
            />}
            {/* {reclaim_purchase_methods && reclaim_purchase_methods.length == 2 && open.reclaim && <ReclaimPurchase 
                open={open.reclaim}
                onClose={() => onCloseItem('reclaim')}
            />} */}
            {/* {reclaim_purchase_methods && reclaim_purchase_methods.length == 1 && showReclaimPurchaseTransactionCode && open.reclaim && <ReclaimPurchaseTransactionCode 
                open={open.reclaim}
                onClose={() => onCloseItem('reclaim')}
            />} */}
            {reclaim_purchase_methods && <ReclaimPurchaseTransactionCode 
                open={open.reclaim}
                onClose={() => onCloseItem('reclaim')}
            />}
        </Grid>
    );
}